import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { PurchasedGoodsWaterUsage } from "../../../../api";

export const purchasedGoodsWaterUsageKeys = {
  items: () => ["purchasedGoodsWaterUsageItems"]
};

export function useGetPurchasedGoodsWaterUsageItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...purchasedGoodsWaterUsageKeys.items(), params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(PurchasedGoodsWaterUsage.getPurchasedGoodsWaterUsageItems, params), config);
}

export function useAddPurchasedGoodsWaterUsageItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(PurchasedGoodsWaterUsage.addPurchasedGoodsWaterUsageItems, { questionnaireId, data }), config);
}

export function useUpdatePurchasedGoodsWaterUsageItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(PurchasedGoodsWaterUsage.updatePurchasedGoodsWaterUsageItem, { questionnaireId, recordId, data }), config);
}

export function useDeletePurchasedGoodsWaterUsageItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(PurchasedGoodsWaterUsage.deletePurchasedGoodsWaterUsageItem, { questionnaireId, recordId }), config);
}

export function useImportPurchasedGoodsWaterUsageItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(PurchasedGoodsWaterUsage.importPurchasedGoodsWaterUsageItems, { questionnaireId, data }), config);
}

export function useDownloadPurchasedGoodsWaterUsageTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId }) =>
    callApi(PurchasedGoodsWaterUsage.getTemplate, questionnaireId), config);
}
